import React, { useState, useRef, useEffect } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import { toast } from "sonner";
import {
  fetchPermissionsList,
  searchPermissions,
  togglePermissionStatus,
} from "../../services/axios/apiManager";
import PermissionsDetails from "./permissionDetails";
import LoadingSpinner from "../../Components/spinner";
import BSPagination from "../../Components/pagination";
import { useNavigate } from "react-router-dom";
import { handleErrors } from "../../services/dataManager";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
const PermissionsList = ({
  permissions,
  setPermissions,
  pagination,
  setPagination,
  granted,
}) => {
  const tableRef = useRef(null);
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [filters, setFilters] = useState(4);
  const [filtering, setFiltering] = useState(false);
  const [modalOptions, setModalOptions] = useState({});
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [selectedPermission, setSelectedPermission] = useState(null);

  // // // Change the page
  const handlePageChange = async (page) => {
    const temp = { ...pagination };
    setPagination((prev) => ({ ...prev, currentPage: page }));
    temp.currentPage = page;
    fetchPermissions(temp);
  };

  // // // fetch Permissions with pagination
  const fetchPermissions = async (pgntn, str = "") => {
    setFiltering(true);
    const res = await fetchPermissionsList(
      pgntn.currentPage,
      pgntn.pageSize,
      str,
    );
    if (res?.data?.success && res?.data?.data) {
      setPermissions(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else {
      await handleErrors(res, navigate);
    }
    setFiltering(false);
  };
  // // // status = 0-Inactive, 1-Active, 2-deleted, 3 default
  // // // Fetch Filtered Permission
  const fetchFilteredPermissions = async (e) => {
    setFilters(e.target.value);
    const string = `status=${e.target.value}`;
    await fetchPermissions(pagination, string);
  };

  // // // Search Permissions Logic
  const handleSearch = async (e) => {
    const string = e.target.value.trim();
    setQuery(string);

    if (string?.length > 0) {
      const results = await searchPermissions(string);
      if (results?.data?.data) {
        setPermissions(results.data.data);
      }
    } else {
      fetchPermissions(pagination);
    }
  };

  // // // Change Status Logic
  const handleStatusChange = async (perm) => {
    if (!granted.some((g) => g.type === "toggle-status")) {
      toast.error(
        "You don't have neccessary permissions to do this operation!",
        { duration: 3000 },
      );
      return;
    }
    setModalOptions({
      header: "Change Status",
      body: `Are you sure you want to change the status of role "${perm.description}"?`,
      okay: "Change",
      method: changeStatus,
      data: { id: perm.id, status: perm.status === 1 ? 0 : 1 },
    });
    setShowOptionsModal(true);
  };

  const changeStatus = async (data) => {
    const res = await togglePermissionStatus(data);
    if (res?.data?.success === true) {
      await fetchPermissions(pagination);
      toast.success("Permission status has been updated", { duration: 2000 });
    } else {
      await handleErrors(res, navigate);
    }
    setModalOptions({});
    setShowOptionsModal(false);
  };

  const handleCloseOptionsModal = () => {
    setModalOptions({});
    setShowOptionsModal(false);
  };
  // // // Details Modal open Logic
  const handleOpendetailsModal = (perm) => {
    setSelectedPermission(perm);
    setOpenDetailsModal(true);
  };

  // // // Reset the filter to default
  const resetFilters = async () => {
    setFilters(3);
    setQuery("");
    await fetchPermissions(pagination);
  };

  useEffect(() => {
    const $table = $(tableRef.current);
    const rows = permissions.map((perm) => {
      // // // // Plain text just to show the status
      const statusBtn = `<span class=${perm.status === 1 ? "text-success" : "text-danger"} style=cursor:default>${perm.status === 1 ? "Active" : "In-Active"}</span>`;

      // // // // Status button if needs to changes the status of permissions
      // `<button class="btn btn-sm status-btn ${
      //   perm.status === 1 ? "text-success" : "text-danger"
      // }" data-id="${perm.id}" title="change status">` +
      // `${perm.status === 1 ? "Active" : "Inactive"}</button>`;

      const viewBtn =
        `<button class="btn btn-sm btn-outline-success view-btn" data-id="${perm.id}" title="View">` +
        `<i class="fas fa-eye"></i></button>`;

      return [perm.description, perm.module?.name || "", statusBtn, viewBtn];
    });

    const config = {
      data: rows,
      columns: [
        { title: "Description" },
        { title: "System Module" },
        { title: "Status", orderable: false },
        { title: "Actions", orderable: false },
      ],
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
    };

    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $table.DataTable().clear().rows.add(rows).draw();
    } else {
      $table.DataTable(config);
    }

    // Delegate click events
    $table.off("click", ".status-btn").on("click", ".status-btn", function () {
      const id = $(this).data("id");
      const perm = permissions.find((p) => p.id === id);
      handleStatusChange(perm);
    });

    $table.off("click", ".view-btn").on("click", ".view-btn", function () {
      const id = $(this).data("id");
      const perm = permissions.find((p) => p.id === id);
      setSelectedPermission(perm);
      setOpenDetailsModal(true);
    });

    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $table.DataTable().destroy();
      }
    };
  }, [permissions, granted]);

  return (
    <div>
      <div className="container py-4 text-light bg-dark rounded mb-4">
        <div className="row align-items-center mb-4">
          <div className="col-md-4">
            <Form.Control
              type="text"
              placeholder="Search Permissions..."
              value={query}
              onChange={(e) => {
                handleSearch(e);
              }}
              className="bg-dark text-light border-light input-placeholder-light"
            />
          </div>
          <div className="col-md-4">
            <Form.Select
              name="status"
              value={filters}
              onChange={(e) => {
                fetchFilteredPermissions(e);
              }}
              className="bg-dark border-light text-light"
            >
              <option value="3">Active & Inactive</option>
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </Form.Select>
          </div>
          <div className="col-md-1">
            {filtering ? (
              <LoadingSpinner size={"md"} />
            ) : (
              <div className="row ">
                <Button
                  title="Reset Filters And Rrfresh Records"
                  className="btn btn-success"
                  onClick={() => {
                    resetFilters();
                  }}
                >
                  Reset
                </Button>
              </div>
            )}
          </div>
        </div>
        <div className="table-responsive">
          <table
            ref={tableRef}
            className="table table-dark table-hover w-100"
          />
        </div>
        <div className="d-flex justify-content-end mt-3">
          <div className="mx-4 py-2">
            <span className="text-light">{`Rows/Page ${pagination.pageSize || 0}, Total records ${pagination?.totalRecords || 0}`}</span>
          </div>
          <BSPagination
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            onPageChange={handlePageChange}
            siblingCount={2}
            showFirstLast
          />
        </div>
      </div>
      {/* /////////Permission Details Modal//////////////////// */}
      <PermissionsDetails
        selectedPermission={selectedPermission}
        setSelectedPermission={setSelectedPermission}
        openDetailsModal={openDetailsModal}
        setOpenDetailsModal={setOpenDetailsModal}
      />
      {/* /////////Options Modal//////////////////// */}
      <Modal
        show={showOptionsModal}
        onHide={handleCloseOptionsModal}
        centered
        className="text-light"
      >
        <Modal.Header closeButton className="bg-dark text-light border-0">
          <Modal.Title>{modalOptions.header}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark text-light">
          {modalOptions.body}
        </Modal.Body>
        <Modal.Footer className="bg-dark text-light border-0">
          <Button variant="secondary" onClick={handleCloseOptionsModal}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              modalOptions.method(modalOptions.data);
            }}
          >
            {modalOptions.okay}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default PermissionsList;
